import React from 'react';
import { apiRequest } from '../actions/apiActions';
import {
  showLoading,
  hideLoading,
  addUiMsg,
  updateApiSpinner,
} from '../actions/uiActions';
import { apiUrls, apiVersion } from '../../apiUrls';
import {
  LOAD_LOW_BATT_REPORT,
  PROCESS_LOW_BATT_REPORT,
  LOAD_DORMANT_DEVICES_REPORT,
  PROCESS_DORMANT_DEVICES_REPORT,
  LOAD_MISSING_DEVICES_REPORT,
  PROCESS_MISSING_DEVICES_REPORT,
  insertLowBattReport,
  insertDormantDevicesReport,
  insertMissingDevicesReport,
  REPORTS_ERROR,
  LOAD_ACTIVE_TAMPER_REPORT,
  PROCESS_ACTIVE_TAMPER_REPORT,
  insertActivetamperreport,
  LOAD_AUDIT_LOGS_REPORT,
  PROCESS_AUDIT_LOGS_REPORT,
  PROCESS_APPEND_AUDIT_LOGS_REPORT,
  insertAuditLogsReport,
  appendAuditLogsReport,
  appendActiveTamperReport,
  PROCESS_APPEND_ACTIVE_TAMPER_REPORT,
  appendMissingDevicesReport,
  PROCESS_APPEND_MISSING_DEVICES_REPORT,
  appendLowBattReport,
  PROCESS_APPEND_LOWBATT_REPORT,
  appendDormantDevicesReport,
  PROCESS_APPEND_DORMANT_DEVICES_REPORT
} from '../actions/reportsActions';

import { messageTypes } from '../../components/ui/AlertMessage';
import { FormattedMessage } from 'react-intl';
import { errorDisplay } from '../../utilities/general';

export const loadLowBattReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === LOAD_LOW_BATT_REPORT) {
    const body = null;
    const meta = {
      method: 'GET',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].lowbatteryreport,
      onSuccess: PROCESS_LOW_BATT_REPORT,
      onError: REPORTS_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };

    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ lowBattReportLoaded: false }));
    store.dispatch(apiRequest(body, meta));
  }
};

export const processLowBattReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_LOW_BATT_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess:PROCESS_APPEND_LOWBATT_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ lowBattReportLoaded: true }));
    }
   
    store.dispatch(insertLowBattReport(action.payload.results));
  }
};
export const processAppendLowBattReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_APPEND_LOWBATT_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_LOWBATT_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ lowBattReportLoaded: true }));
    }
   
    store.dispatch(appendLowBattReport(action.payload.results));
  }
};

export const loadDormantDevicesReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === LOAD_DORMANT_DEVICES_REPORT) {
    const body = null;
    const meta = {
      method: 'GET',
      url:
        apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].dormantdevicereport,
      onSuccess: PROCESS_DORMANT_DEVICES_REPORT,
      onError: REPORTS_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };

    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ dormantDevicesReportReturned: false }));
    store.dispatch(apiRequest(body, meta));
  }
};

export const processDormantDevicesReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_DORMANT_DEVICES_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_DORMANT_DEVICES_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ dormantDevicesReportReturned: true }));
    }
    store.dispatch(insertDormantDevicesReport(action.payload.results));
  }
};
export const  processAppendDormantDevicesReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_APPEND_DORMANT_DEVICES_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_DORMANT_DEVICES_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({  dormantDevicesReportReturned: true }));
    }
   
    store.dispatch(appendDormantDevicesReport(action.payload.results));
  }
};

export const loadMissingDevicesReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === LOAD_MISSING_DEVICES_REPORT) {
    const body = null;
    const meta = {
      method: 'GET',
      url:
        apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].missingdevicesreport,
      onSuccess: PROCESS_MISSING_DEVICES_REPORT,
      onError: REPORTS_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };

    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ missingDevicesReturned: false }));
    store.dispatch(apiRequest(body, meta));
  }
};

export const processMissingDevicesReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_MISSING_DEVICES_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_MISSING_DEVICES_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ missingDevicesReturned: true }));
    }

    store.dispatch(insertMissingDevicesReport(action.payload.results));
  }
};
export const processAppendMissingDevicesReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_APPEND_MISSING_DEVICES_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_MISSING_DEVICES_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ missingDevicesReturned: true }));
    }
   
    store.dispatch(appendMissingDevicesReport(action.payload.results));
  }
};

export const loadActivetamperreport = (store) => (next) => (action) => {
  next(action);
  if (action.type === LOAD_ACTIVE_TAMPER_REPORT) {
    const body = null;
    const meta = {
      method: 'GET',
      url:
        apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].activetamperreport,
      onSuccess: PROCESS_ACTIVE_TAMPER_REPORT,
      onError: REPORTS_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };

    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ activeTamperReportReturned: false }));
    store.dispatch(apiRequest(body, meta));
  }
};

export const processActivetamperreport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_ACTIVE_TAMPER_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        // onSuccess: PROCESS_ACTIVE_TAMPER_REPORT,
        onSuccess:PROCESS_APPEND_ACTIVE_TAMPER_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ activeTamperReportReturned: true }));
    }
  
    store.dispatch(insertActivetamperreport(action.payload.results));
  }
};

export const processAppendActiveTamperReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_APPEND_ACTIVE_TAMPER_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess:  PROCESS_APPEND_ACTIVE_TAMPER_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ activeTamperReportReturned: true }));
    }
   
    store.dispatch(appendActiveTamperReport(action.payload.results));
  }
};
export const reportLoadError = (store) => (next) => (action) => {
  next(action);
  if (action.type === REPORTS_ERROR) {
    store.dispatch(hideLoading());
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="reportsMiddleware.reportsErrorText"
          defaultMessage="There was an error"
          description="The user statuses were not able to be loaded"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};

export const loadAuditLogsReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === LOAD_AUDIT_LOGS_REPORT) {
    const body = null;
    const meta = {
      method: 'GET',
      url:
        apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].auditLogs,
      onSuccess: PROCESS_AUDIT_LOGS_REPORT,
      onError: REPORTS_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };

    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ auditLogsReportReturned: false }));
    store.dispatch(apiRequest(body, meta));
  }
};

export const processAuditLogsReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_AUDIT_LOGS_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_AUDIT_LOGS_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ auditLogsReportReturned: true }));
    }
    store.dispatch(insertAuditLogsReport(action.payload.results));
  }
};

export const processAppendAuditLogsReport = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_APPEND_AUDIT_LOGS_REPORT) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_AUDIT_LOGS_REPORT,
        onError: REPORTS_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
    }
    store.dispatch(updateApiSpinner({ auditLogsReportReturned: true }));
    store.dispatch(appendAuditLogsReport(action.payload.results));
  }
};

export const reportsMdl = [
  loadLowBattReport,
  processLowBattReport,
  loadDormantDevicesReport,
  processDormantDevicesReport,
  loadMissingDevicesReport,
  processMissingDevicesReport,
  loadActivetamperreport,
  processActivetamperreport,
  loadAuditLogsReport,
  processAuditLogsReport,
  processAppendAuditLogsReport,
  reportLoadError,
  processAppendActiveTamperReport,
  processAppendMissingDevicesReport,
  processAppendLowBattReport,
  processAppendDormantDevicesReport
];
